import {
	MESApiService,
	type spParameter,
} from "../../../../services/ApiService";

export const upsertSettings = async ({
	oldName,
	newName,
	description,
	value,
}: {
	oldName: string | null;
	newName: string;
	description: string;
	value: string;
}) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "OldName", value: oldName },
		{ name: "NewName", value: newName },
		{ name: "Description", value: description },
		{ name: "Value", value: value },
	];

	const resp = await apiService.callV2("[UTL].[SetSetting]", parameters);

	if (!resp.ok) {
		throw new Error(resp.message || "Error when upsert setting");
	}
};

export const deleteSetting = async (settingName: string) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "SettingName", value: settingName },
	];

	const resp = await apiService.callV2("[UTL].[DeleteSetting]", parameters);

	if (!resp.ok) {
		throw new Error(resp.message || "Error when delete setting");
	}
};
